import { Avatar, AvatarFallback, AvatarImage, cn } from "@tellescope/ui";
import type { OrganizationTheme } from "@tellescope/types-models";
import { formatInitials } from "@tellescope/utils";

interface OrganizationAvatarProps {
  organization: OrganizationTheme;
  className?: string;
}

// Uses the organization's icon (favicon) rather than its logo — logos rarely fit
// a small circular avatar. Renders nothing when the organization has no icon.
export const OrganizationAvatar = ({ organization, className }: OrganizationAvatarProps) => {
  if (!organization.faviconURL) return null;

  return (
    <Avatar className={cn("h-8 w-8 flex-shrink-0", className)}>
      <AvatarImage src={organization.faviconURL} />
      <AvatarFallback useStaticBackground id={organization.businessId}>
        {formatInitials(organization.name)}
      </AvatarFallback>
    </Avatar>
  );
};
